angular.module('webcomm').controller('SpeakingEventController',
    ['$scope', '$log', '$interval', '$timeout', 'timeFormattingService', function ($scope, $log, $interval, $timeout, timeFormattingService) {
        let endpointId = $scope.feedEvent.data.endpointId;
        let startedSpeaking = $scope.feedEvent.data.startedSpeaking;
        let finishedSpeaking = $scope.feedEvent.data.finishedSpeaking;

        $scope.timeSent = timeFormattingService.formatFeedDate($scope.feedEvent.clientTime);
        $scope.leftOrRight = $scope.feedEvent.data.self ? "right" : "left";

        let timer;
        if (finishedSpeaking) {
            destroyScopes(); // no further updates - delete watchers
            $scope.duration = getDuration(startedSpeaking, finishedSpeaking);
        } else {
            $scope.duration = getDuration(startedSpeaking, new Date());
            timer = startTimer();
        }

        function getDuration(startedSpeaking, finishedSpeaking) {
            return Math.floor((finishedSpeaking.getTime() - startedSpeaking.getTime()) / (1000));
        }

        function startTimer() {
            return $interval(tick, 1000);
            function tick() {
                $scope.duration = getDuration(startedSpeaking, new Date());
            }
        }

        function stopTimer() {
            if (timer) {
                $interval.cancel(timer);
            }
        }

        // destroy scopes and watchers.
        function destroyScopes() {
            $timeout(function() {
                $scope.$parent.$parent.$destroy();
            }, 0);
        }

        var unbindFeedEventReceived = $scope.$on('feedModel.feedEventReceived', function (event, data) {
            if (data.type === "end-speaking" && data.data.endpointId === endpointId) {
                stopTimer();
                destroyScopes();
            }
        });

        $scope.$on('$destroy', function () {
            unbindFeedEventReceived();
            stopTimer();
        });
    }]);